import { Checkbox, Col, Radio, Row, Select, Space } from "antd"
import { GetCityWithSection } from "hooks/returnCityName"
import Locations from "components/Common/Locations"

import React, { useEffect } from "react"
import { useState } from "react"

export const ListEngineerMultiple = ({ props, selectEngineers, selectedEngineers = [] }) => {
  const { lstEngineer } = props

  const [engGrad, setEngGrad] = useState(0)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [filterCity, setFilterCity] = useState(false)

  const filteredEngineers = lstEngineer?.filter(
    d =>
      (engGrad === 0 || d.engineerGradeTypeEnum === engGrad) &&
      (filterCity === false || d.idSection === dataAddress.sectionId)
  )

  const countLstEng = filteredEngineers?.length

  useEffect(() => {
    const { onGetListEngineer } = props
    if (onGetListEngineer) {
      onGetListEngineer()
    }
  }, [])

  const handleChange = values => {
    console.log("Selected engineers:", values)
    selectEngineers(values)
  }

  return (
    <>
      <Row gutter={[8, 16]} align="middle">
        <Col>
          <Radio.Group
            onChange={e => setEngGrad(e.target.value)}
            defaultValue={0}
            size="small"
          >
            <Space direction="horizontal">
              <Radio.Button value={0}>
                {engGrad === 0 ? countLstEng : ""} همه
              </Radio.Button>
              <Radio.Button value={1}>
                {engGrad === 1 ? countLstEng : ""} ارشد
              </Radio.Button>
              <Radio.Button value={2}>
                {engGrad === 2 ? countLstEng : ""} پایه 1
              </Radio.Button>
              <Radio.Button value={3}>
                {engGrad === 3 ? countLstEng : ""} پایه 2
              </Radio.Button>
              <Radio.Button value={4}>
                {engGrad === 4 ? countLstEng : ""} پایه 3
              </Radio.Button>
            </Space>
          </Radio.Group>
        </Col>

        <Col>
          <Checkbox
            onChange={e => {
              setFilterCity(e.target.checked)
            }}
          >
            فیلتر شهر
          </Checkbox>
        </Col>
        {filterCity && (
          <Col className="gutter-row">
            <Locations setDataAddress={setDataAddress} isAccessCity={true} />
          </Col>
        )}
      </Row>
      <Row style={{ marginTop: 8 }}>
        <Col span={24}>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            showSearch
            allowClear
            placeholder="انتخاب کارشناس (چند انتخابی)"
            onChange={handleChange}
            value={selectedEngineers}
            maxTagCount="responsive"
            filterOption={(input, option) =>
              (option.label || "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {filteredEngineers?.map(engineer => (
              <Select.Option
                key={engineer.id}
                value={engineer.id}
                label={
                  engineer.fullDescription +
                  GetCityWithSection(engineer.idSection)
                }
              >
                <div
                  style={{
                    color:
                      engineer.totalQuotaBalance <= 0 ||
                      engineer.fullDescription.indexOf("ندارد") !== -1
                        ? "red"
                        : "green",
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        engineer.fullDescription +
                        GetCityWithSection(engineer.idSection),
                    }}
                  />
                </div>
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    </>
  )
}
